
import { createJSONStorage, persist } from 'zustand/middleware';

export const persistConfig = (key: string) => ({
  name: key,
  storage: createJSONStorage(() => localStorage),
});
